import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
export const style = css`
  :host {
    display: block;
  }
  
  .review-product-container{
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
  }
  .product-details {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto;
    align-items: start;
    column-gap: 1rem;
  }
  .product-details cse-text[variant="product-title-m"] {
    grid-column: 1;
    grid-row: 1;
    justify-self: start;
  }
  .product-details cse-text:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
    justify-self: start;
  }
  .product-details cse-text:last-child {
    grid-column: 2;
    grid-row: 1 / span 2;
    align-self: center;
    justify-self: end;
  }
  .test{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06}
  }

  .product-details .quantity-correction {
    grid-column: 2;
    grid-row: 1 / span 2;
    align-self: center;
    justify-self: end;
    display: flex;
    gap: ${csSpacing.spacing04};
  }

  .quantity-original {
    text-decoration: line-through;
  }
`
